<template>
  <div>
    <Loader :loader="sending" />

    <div class="wrapper-content">
      <Encabezado :elementos="headerInfo" />
      <ParameterTable
        v-show="showAction(1)"
        id="Table"
        :change-action="changeAction"
        :list="list"
        :headers="headers"
        :get="get"
      />
      <ParameterForm
        v-if="showAction(2) || showAction(3)"
        id="Form"
        :model="model"
        @getParameter="getParameter"
        :change-action="changeAction"
        :resetAction="resetForm"
      />
    </div>
  </div>
</template>
<script>
import Loader from "@/components/Loader.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import ParameterTable from "./ParameterTable.vue";
import ParameterForm from "./ParameterForm.vue";
import { ParameterRequest } from "@/core/request";
export default {
  name: "PARAMETERS",
  data: () => ({
    sending: false,
    list: [],
    action: 1,
    headers: [
      { text: "ID Parámetro", value: "idParameter", align: "center" },
      { text: "Nombre", value: "name", align: "center" },
      { text: "Unidad de Medida", value: "unitMeasurement", align: "center" },
      { text: "Categoría", value: "category.name", align: "center" },
      { text: "Perfil de estudio", value: "category.studyModality.name", align: "center" },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    model: {
      category: {},
    },
  }),
  components: {
    Loader,
    Encabezado,
    ParameterTable,
    ParameterForm,
  },
  computed: {
    headerInfo() {
      return {
        icono: "mdi-pencil-circle-outline",
        texto: "Parámetros",
      };
    },
  },
  created() {
    this.fetchParameters();
  },
  methods: {
    showAction(action) {
      return this.action === action;
    },
    changeAction(action) {
      this.action = action;
    },
    async fetchParameters() {
      try {
        this.sending = true;
        const response = await ParameterRequest.listAllParameter();
        this.list = response.data.data.map(
          ({
            idParameter,
            name,
            unitMeasurement = "",
            type,
            category = "",
            referenceValues,
            parameterAliaslist,
            ...rest
          }) => ({
            ...rest,
            idParameter,
            name,
            unitMeasurement,
            type,
            category,
            referenceValues,
            parameterAliaslist,
          })
        );
      } catch (error) {
        this.$utilFront.errorhttp(error);
      } finally {
        this.sending = false;
      }
    },
    get(item) {
      this.sending = true;
      if (item) {
        this.getData(item);
      } else {
        this.sending = false;
        this.changeAction(1);
      }
    },

    getData(item) {
      this.sending = true;
      ParameterRequest.getParameter({idParameter: item.idParameter}).then((response) => {
          const { code, status, data } = response.data;
          if (code === 200 && status === "OK") {
            this.model = data;
            this.changeAction(3);
          }
        })
        .catch((e) => {
          this.$utilFront.errorhttp(e, "ERROR");
        }).finally(()=>{
          this.sending = false;
        })
     
    },
    resetForm() {
      this.model = {
        category: {},
      };
      this.changeAction(1);
    },
    async getParameter(values) {
      try {
        const reqParams = {
          ...values,
        };
        this.sending = true;

        const response =
          this.action === 2
            ? await ParameterRequest.addParameter(reqParams)
            : await ParameterRequest.updateParameter(reqParams);

        const { code, status } = response.data;
        if (code === 200 && status === "OK") {
          this.$utilFront.notifications(
            "Información registrada correctamente",
            "SUCCESS"
          );
          this.changeAction(1);
          this.fetchParameters();
        }
      } catch (e) {
        console.log(e);
        this.$utilFront.errorhttp(e, "ERROR");
      } finally {
        this.changeAction(1);
        this.sending = false;
      }
    },
  },
};
</script>
